import moduleDescriptions from 'root/src/shared/descriptions/modules'
import { listModuleLenses } from 'root/src/client/logic/list/lenses'

const { viewListTitle } = listModuleLenses

export default (state, { moduleId }) => viewListTitle(moduleId, moduleDescriptions)
